module.exports = __webpack_public_path__ + "img/Arte.3eb476fd.svg";